/**
 * Training Recommendations translations
 * Training recommendations page UI text
 */

import { LANGUAGES } from '../config';

export const trainingTranslations = {
  [LANGUAGES.EN]: {
    title: 'Training Recommendations',
    skillGaps: 'Skill Gaps',
    recommendations: 'Recommendations',
    course: 'Course',
    provider: 'Provider',
    duration: 'Duration',
    cost: 'Cost',
    priority: 'Priority',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    noGaps: 'No skill gaps identified',
    noRecommendations: 'No training recommendations found',
    generateRecommendations: 'Generate Recommendations',
    savedSuccessfully: 'Training recommendations saved successfully!',
    generationFailed: 'Failed to generate training recommendations',
    processing: 'Generating recommendations...',
    selectUser: 'Select User',
    selectUserToAnalyze: 'Select a user to analyze training needs',
    trainingStatus: 'Training Status',
    completed: 'Completed',
    inProgress: 'In Progress',
    notStarted: 'Not Started',
    startDate: 'Start Date',
    endDate: 'End Date',
    certificate: 'Certificate',
    viewCertificate: 'View Certificate',
    downloadCertificate: 'Download Certificate',
    recommendedFor: 'Recommended for',
    basedOn: 'Based on',
    cvAnalysis: 'CV Analysis',
    jobRequirements: 'Job Requirements',
    companyNeeds: 'Company Needs',
    skillGap: 'Skill Gap',
    currentLevel: 'Current Level',
    requiredLevel: 'Required Level',
    noDataAvailable: 'No data available for training recommendations'
  },
  [LANGUAGES.FR]: {
    title: 'Recommandations de Formation',
    skillGaps: 'Lacunes de Compétences',
    recommendations: 'Recommandations',
    course: 'Cours',
    provider: 'Fournisseur',
    duration: 'Durée',
    cost: 'Coût',
    priority: 'Priorité',
    high: 'Élevée',
    medium: 'Moyenne',
    low: 'Faible',
    noGaps: 'Aucune lacune de compétences identifiée',
    noRecommendations: 'Aucune recommandation de formation trouvée',
    generateRecommendations: 'Générer des Recommandations',
    savedSuccessfully: 'Recommandations de formation enregistrées avec succès!',
    generationFailed: 'Échec de la génération des recommandations de formation',
    processing: 'Génération des recommandations...',
    selectUser: 'Sélectionner un Utilisateur',
    selectUserToAnalyze: 'Sélectionnez un utilisateur pour analyser les besoins de formation',
    trainingStatus: 'Statut de Formation',
    completed: 'Complété',
    inProgress: 'En Cours',
    notStarted: 'Non Commencé',
    startDate: 'Date de Début',
    endDate: 'Date de Fin',
    certificate: 'Certificat',
    viewCertificate: 'Voir le Certificat',
    downloadCertificate: 'Télécharger le Certificat',
    recommendedFor: 'Recommandé pour',
    basedOn: 'Basé sur',
    cvAnalysis: 'Analyse de CV',
    jobRequirements: 'Exigences du Poste',
    companyNeeds: 'Besoins de l\'Entreprise',
    skillGap: 'Lacune de Compétence',
    currentLevel: 'Niveau Actuel',
    requiredLevel: 'Niveau Requis',
    noDataAvailable: 'Aucune donnée disponible pour les recommandations de formation'
  }
};
